export default [
  {
    name: '30万',
    value: '3'
  },
  {
    name: '50万',
    value: '5'
  },
  {
    name: '100万',
    value: '10'
  },
  {
    name: '150万',
    value: '15'
  }
]



// WEBPACK FOOTER //
// ./src/data/insuranceAmounts.js